import { StepForm } from '@iq-firebolt/client'
import fireboltBlueberry from '@iq-firebolt/blueberry-theme'

import LoadingStep from 'components/StepTemplates/LoadingStep'
import FormContainer from 'components/common/FormContainer'
import ActionButtons from 'components/common/ActionButtons'

import useFirstStep from './hook'
import useRedirectTransitionError from 'hooks/useRedirectTransitionError'
import './style.styl'
import PrivacyPolicy from 'components/common/PrivacyPolicy'
import { FormTitle } from 'components/common/FormTitle'

const NewFirstStepIntro = ({
  autoFill = {},
  fireboltStep,
  customGoBack,
  onBlurField,
  onChangeField,
  partnerFormName,
  partnerBrand,
}) => {
  const { handleGoBackform, runBeforeChangeStep, handleSubmit } = useFirstStep({
    fireboltStep,
    customGoBack,
    partnerFormName,
    partnerBrand,
  })

  const errorRedirect = {
    'no_account_holder': '/produto/bb-ourocard/pre-cadastro',
  }

  const { redirectTransitionError } = useRedirectTransitionError(errorRedirect)

  return redirectTransitionError ? (
    <>
      <FormContainer
        className="bbourocard-first-step__container"
        imageSrc="images/bb/ourocard-novo.png">
        <div>
          <FormTitle
            title="Vamos começar!"
            description="Você está a poucos passos de conquistar seu cartão"
            hasRequiredFieldWarning
            largeSize
          />
          <StepForm
            onBlurField={onBlurField}
            onChangeField={onChangeField}
            theme={fireboltBlueberry}
            onSubmit={handleSubmit}
            autoFill={{ ...autoFill }}
            customActionsChild={({ formData }) => (
              <ActionButtons
                formData={formData}
                onGoBack={handleGoBackform}
                beforeSubmitStep={runBeforeChangeStep}
              />
            )}
          />
          <PrivacyPolicy />
        </div>
      </FormContainer>
    </>
  ) : (
    <LoadingStep />
  )
}

export default NewFirstStepIntro
